import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";
import {IFoundation} from "../Interfaces/IFoundation";

export const Bold = styled.div`
  font-weight: ${(props: IFoundation) => props.theme.fontWeights.bold};
`

export const SemiBold = styled.div`
  font-weight: ${(props: IFoundation) => props.theme.fontWeights.semiBold};
`